import { Link } from "react-router-dom";
import { useMiniSite } from "../../components/minisite/context";
import { InquirySection, BookingStatusCard } from "../RentalProfile";
import { ShieldCheck, CalendarDays, ExternalLink } from "lucide-react";

export default function MiniSiteBooking() {
  const { data, theme } = useMiniSite();

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-testid="ms-booking-page">
      <h1 className="font-display text-3xl sm:text-4xl font-bold" style={{ color: theme }}>
        {data.online_booking_enabled
          ? (data.booking_mode === "automatic_hold" ? "Book online" : "Request a booking")
          : "Send a booking inquiry"}
      </h1>
      <p className="text-sm text-slate-600 mt-1 max-w-2xl">
        {data.booking_mode === "automatic_hold"
          ? "Select your dates and we'll hold the vehicle for you. The business will follow up with a final confirmation."
          : "Send your requested dates and a short message. The business reviews and replies with a confirmation through ConfirmPH so both sides have a clear record."}
      </p>

      <div className="mt-6 grid lg:grid-cols-3 gap-4">
        <div className="lg:col-span-2">
          {data.online_booking_enabled && (
            <div className="rounded-xl border border-emerald-200 bg-emerald-50/60 p-4 mb-4 flex items-start gap-3" data-testid="ms-booking-online-cta">
              <CalendarDays className="w-5 h-5 text-emerald-700 mt-0.5" />
              <div className="flex-1">
                <div className="font-display font-semibold text-emerald-900">
                  {data.booking_mode === "automatic_hold" ? "Online booking is open" : "Online booking requests are open"}
                </div>
                <p className="text-sm text-emerald-900/80 mt-1">
                  Continue to the full booking form to enter dates, vehicle, and your contact details.
                </p>
                <Link
                  to={`/business/${data.id}`}
                  data-testid="ms-booking-open-flow"
                  className="mt-2 inline-flex items-center gap-1.5 px-4 py-2 rounded-lg text-white text-sm font-medium"
                  style={{ background: theme }}
                >
                  {data.booking_mode === "automatic_hold" ? "Book now" : "Request booking"} <ExternalLink className="w-3.5 h-3.5" />
                </Link>
              </div>
            </div>
          )}

          <InquirySection id={data.id} businessName={data.name} onClose={() => {}} />
        </div>

        <aside className="space-y-3">
          <BookingStatusCard card={data} />
          <div className="rounded-xl border border-slate-200 bg-white p-4 flex items-start gap-3">
            <ShieldCheck className="w-5 h-5 mt-0.5" style={{ color: theme }} />
            <div>
              <div className="font-medium text-slate-900 text-sm">Confirmation via ConfirmPH</div>
              <p className="text-xs text-slate-600 mt-1">
                The business can confirm your booking through ConfirmPH so both sides have a clear record.
              </p>
            </div>
          </div>
        </aside>
      </div>
    </div>
  );
}
